/**
 * Card body spacing — controls both padding and (when `bodyFlex` is true) gap.
 *
 * | Key     | Value |
 * |---------|-------|
 * | `tight` | 8 px  |
 * | `default` | 10 px |
 * | `wide`  | 16 px |
 * | `extra-wide`  | 24 px |
 */
export const RV_CARD_SPACING = {
    tight: "tight",
    default: "default",
    wide: "wide",
    extraWide: "extra-wide",
} as const;

export type RVCardSpacing = (typeof RV_CARD_SPACING)[keyof typeof RV_CARD_SPACING];

/**
 * Card surface variant.
 *
 * | Key      | Appearance             |
 * |----------|------------------------|
 * | `raised` | Drop shadow + border   |
 * | `flat`   | Border only, no shadow |
 */
export const RV_CARD_VARIANT = {
    raised: "raised",
    flat: "flat",
} as const;

export type RVCardVariant = (typeof RV_CARD_VARIANT)[keyof typeof RV_CARD_VARIANT];
